import receipt from './receipt';
import commonApi from './common_api';

export default {
	receipt,
	commonApi
};